import { PlaceholderPage } from './PlaceholderPage';

export const PaymentSetupPage = () => <PlaceholderPage title="Payment Setup" />;
